import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { Grid } from '@material-ui/core';
import GridContainer from '@jumbo/components/GridContainer';
import CmtCard from '../../../../@coremat/CmtCard';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import AddBox from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { StoragesUpdateMethods, StoragesMethods } from '../../../../services/auth';
import { CurrentStoragesUpdateMethods, CurrentStoragesMethod } from '../../../../@jumbo/constants/AppConstants';

const columns = [
  // { id: 'id', label: 'ID', minWidth: 170 },
  { id: 'name', label: 'Name', minWidth: 100 },
  {
    id: 'type',
    label: 'Storage Type',
    minWidth: 170,
  },
  { id: 'region', label: 'Region', minWidth: 100 },
];
function createData(name, type, region) {
  return { name, type, region };
}
const rows = [
  createData('Sanchan Storage', 'Envoi', 'us-east-1'),
  createData('Test Storage', 'AWS', 'us-east-2'),
  createData('Sample Storage', 'Iconik', 'us-west-1'),
];
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Storages(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id, pageType } = useParams();
  const [addStorage, setAddStorage] = useState(false);
  const [name, setName] = useState('');
  const [image, setImage] = useState('');
  const [bucket, setBucket] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [accessKey, setAccessKey] = useState('');
  const [region, setRegion] = useState('');

  const [nameError, setnameError] = useState('');
  const [bucketError, setBucketError] = useState('');
  const [secretKeyError, setSecretKeyError] = useState('');
  const [accessKeyError, setAccessKeyError] = useState('');
  const [regionError, setRegionError] = useState('');

  const handleAddClickOpen = () => {
    setAddStorage(true);
  };
  const addStorageClose = () => {
    setAddStorage(false);
  };
  const token = localStorage.getItem('token');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const submitAddStorage = () => {
    //if (createValidation()) {
    const data = {
      name: name,
      image: image,
      bucket: bucket,
      secretKey: secretKey,
      accessKey: accessKey,
      region: region,
    };
    console.log('data', data);
    console.log('id', id);
    dispatch(StoragesUpdateMethods[CurrentStoragesUpdateMethods].OnStoragesUpdate(token, data, id));
    setAddStorage(false);
    //history.push('/storages');
    //}
  };

  const storagesData = useSelector(
    state => state.auth && state.auth.getstoragesList && state.auth.getstoragesList.length > 0 && state.auth.getstoragesList,
  );

  useEffect(() => {
    dispatch(StoragesMethods[CurrentStoragesMethod].onStoragesList(token, id));
  }, []);

  let StoragesDataList = storagesData && storagesData.length > 0 ? storagesData : [];

  return (
    <Box>
      <Grid>
        <CmtCard className={useStyles.cardRoot}>
          <Box display="flex" alignItems="center" height={1}>
            <Box ml={{ xs: 5, xl: 8 }}>
              <Typography component="div" variant="h4">
                Storages
              </Typography>
            </Box>
            <Box className={classes.clientActions}>
              <IconButton aria-label="Add" className={classes.margin} onClick={handleAddClickOpen}>
                <AddBox />
              </IconButton>
            </Box>
          </Box>
        </CmtCard>
      </Grid>
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map(column => (
                  <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                    {column.label}
                  </TableCell>
                ))}
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            {StoragesDataList && StoragesDataList.length > 0 ? (
              <TableBody>
                {StoragesDataList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                      {columns.map(column => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number' ? column.format(value) : value}
                          </TableCell>
                        );
                      })}
                      <TableCell>
                        <IconButton aria-label="edit" className={classes.margin}>
                          <Edit />
                        </IconButton>
                        <IconButton>
                          <Delete aria-label="delete" className={classes.margin} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            ) : (
              'No Data Found'
            )}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <Box>
        <Dialog
          fullWidth="true"
          maxWidth="md"
          onClose={addStorageClose}
          aria-labelledby="customized-dialog-title"
          open={addStorage}>
          <DialogTitle id="customized-dialog-title" onClose={addStorageClose}>
            Add Storage
          </DialogTitle>
          <DialogContent dividers>
            <GridContainer>
              <Grid item xs={12} sm={6} md={6}>
                <Box display="flex" alignItems="center" mb={{ xs: 4, sm: 6 }}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      className=""
                      id="appModule.name"
                      label="Name"
                      onChange={event => {
                        setName(event.target.value);
                        setnameError('');
                      }}
                      helperText={nameError}
                      defaultValue={name}
                    />
                  </FormControl>
                </Box>
                <Box display="flex" alignItems="center" mb={{ xs: 4, sm: 6 }}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="appModule.image"
                      label="Image"
                      onChange={event => setImage(event.target.value)}
                      defaultValue={image}
                    />
                  </FormControl>
                </Box>
                <Box display="flex" alignItems="center" mb={{ xs: 4, sm: 6 }}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      className=""
                      id="appModule.bucket"
                      label="Bucket"
                      onChange={event => {
                        setBucket(event.target.value);
                        setBucketError('');
                      }}
                      helperText={bucketError}
                      defaultValue={bucket}
                    />
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box display="flex" alignItems="center" mb={{ xs: 4, sm: 6 }}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      className=""
                      id="appModule.secret"
                      label="Secret Key"
                      onChange={event => {
                        setSecretKey(event.target.value);
                        setSecretKeyError('');
                      }}
                      helperText={secretKeyError}
                      defaultValue={secretKey}
                    />
                  </FormControl>
                </Box>
                <Box display="flex" alignItems="center" mb={{ xs: 4, sm: 6 }}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      className=""
                      id="appModule.access"
                      label="Access Key"
                      onChange={event => {
                        setAccessKey(event.target.value);
                        setAccessKeyError('');
                      }}
                      helperText={accessKeyError}
                      defaultValue={accessKey}
                    />
                  </FormControl>
                </Box>
                <Box display="flex" alignItems="center" mb={{ xs: 4, sm: 6 }}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      className=""
                      id="appModule.region"
                      label="Region"
                      onChange={event => {
                        setRegion(event.target.value);
                        setRegionError('');
                      }}
                      helperText={regionError}
                      defaultValue={region}
                    />
                  </FormControl>
                </Box>
              </Grid>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={addStorageClose} color="primary">
              Cancel
            </Button>
            <Button onClick={() => submitAddStorage()} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
